<template>
  <div>
    <b-card
      no-body
      class="px-2"
    >
      <b-row class="align-items-baseline">
        <b-col>
          <b-card-text
            style="margin-top: 10px"
            class="text-bold"
          >
            <feather-icon
              icon="DollarSignIcon"
              size="20"
            /> {{ $t('Weekly Spendings') }}
          </b-card-text>
        </b-col>
        <b-col md="10">
          <Filters
            v-model="form"
            date-type="week"
            :multiple-user-select="true"
            :user-placeholder="$t('All Users')"
            :exclude="['timezone']"
          >
            <template #right-side>
              <div class="text-muted mt-2 mx-2">
                <b>{{ $t('Total Weekly Amount') }}</b>
                <h4
                  style="cursor: pointer;"
                  :class="isAmountBlur ? 'blurry-text' : ''"
                  @click="setIsAmountBlur(!isAmountBlur)"
                >
                  {{ $store.state.project.company.currency || '$' }} {{ number_format(getTotalWeeklySpending, 2) }}
                </h4>
              </div>
            </template>
          </Filters>
        </b-col>
      </b-row>
    </b-card>
    <b-tabs
      id="tour-weekly-spendings"
      class="position-relative"
      pills
    >
      <b-tab :title="$t('Week')">
        <weekly-spending-table
          :search-date="todayDate"
          :format-time="formatTime"
          :search-term="users"
          :set-total-weekly-spending="setTotalWeeklySpending"
          :is-amount-blur="isAmountBlur"
          :set-is-amount-blur="setIsAmountBlur"
          :selected-timezone="selectedTimezone"
          :sort-options="sortOptions"
          @update:sort-options="onSortUpdated"
        />
      </b-tab>

      <template #tabs-end>
        <div class="position-absolute right-0 d-flex">
          <filter-dropdown :include-filters="['tags', 'isOnline']" />
          <sort-by-filter
            :initial-sort-options="sortOptions"
            :options="includedSortOptions"
            @update:sort-options="sortOptions = $event"
          />
        </div>
      </template>
    </b-tabs>
  </div>
</template>
<script>
import {
  BCardText, BRow, BCol, BTab, BTabs, BCard,
} from 'bootstrap-vue'
import Filters from '@/views/common/components/Filter.vue'
import SortByFilter from '@/views/common/components/SortByFilter.vue'
import FilterDropdown from '@/views/common/components/Filters/FilterDropdown.vue'
import { mapGetters } from 'vuex'
import WeeklySpendingTable from './weeklySpending.vue'
import useWeeklySpendings from './useWeeklySpendings'

const moment = require('moment')

const {
  getTotalWeeklySpending, getIsAmountBlur, setIsAmountBlur, setTotalWeeklySpending,
} = useWeeklySpendings()

export default {
  components: {
    BCardText,
    BRow,
    BCol,
    BCard,
    BTab,
    BTabs,
    WeeklySpendingTable,
    Filters,
    SortByFilter,
    FilterDropdown,
  },
  data() {
    const today = this.TODAY({ localTime: false })
    return {
      isAmountBlur: getIsAmountBlur,
      getTotalWeeklySpending,
      setIsAmountBlur,
      setTotalWeeklySpending,
      searchTerm: null,
      searchDate: this.TODAY({ localTime: false }),
      paginationData: {},
      selectedTimezone: localStorage.timezone ?? 'Asia/Kathmandu',
      timezones: [
        { value: null, text: 'Any' },
        { value: 'Asia/Kathmandu', text: 'Asia/Kathmandu' },
        { value: 'Asia/Seoul', text: 'South Korea/Seoul' },
      ],
      form: {
        date: this.TODAY({ localTime: false }),
        start_date: this.TODAY({ localTime: false }),
        end_date: this.TODAY({ localTime: false }),
        month_start: moment().format('YYYY-MM'),
        month_end: moment().format('YYYY-MM'),
        userId: null,
        time_zone: localStorage.timezone ?? 'Asia/Kathmandu',
      },
      sortOptions: {
        sortBy: 'BILLABLE_AMOUNT',
        sortDirection: 'DESC',
      },
      today,
    }
  },
  computed: {
    ...mapGetters('permissions', ['canEditPayment']),
    todayDate() {
      return `${this.form.date} 00:00:00`
    },
    users() {
      return this.form.userId
    },
    includedSortOptions() {
      return ['NAME', 'HOURS_TRACKED', ...(this.canEditPayment ? ['BILLABLE_AMOUNT'] : [])]
    },
  },
  beforeDestroy() {
    this.setIsAmountBlur(true)
  },
  methods: {
    onSortUpdated({ sortBy, sortDirection }) {
      this.sortOptions = { sortBy, sortDirection }
    },
    formatTime(value) {
      const sec = parseInt(value, 10)
      let hours = Math.floor(sec / 3600)
      let minutes = Math.floor((sec - (hours * 3600)) / 60)
      let seconds = sec - (hours * 3600) - (minutes * 60)

      if (hours < 10) { hours = `0${hours}` }
      if (minutes < 10) { minutes = `0${minutes}` }
      if (seconds < 10) { seconds = `0${seconds}` }
      return `${hours}:${minutes}:${seconds}`
    },
    updateTimezone(timezone) {
      this.selectedTimezone = timezone
    },
  },
}
</script>
<style lang="scss" scoped>
.right-0 {
  right: 0;
}

.blurry-text {
  color: transparent !important;
  text-shadow: 0 0 7px rgba(0, 0, 0, 0.6);
  /* Use rgba for better transparency control */
}

.dark-layout {
  .blurry-text {
    text-shadow: 0 0 7px rgba(255, 255, 255, 0.6);
  }
}
</style>
